import { getToken } from "../auth/token";

const RAW_API_BASE = process.env.REACT_APP_API_URL || "";
const API_BASE = RAW_API_BASE.replace(/\/+$/, "").replace(/\/api$/, "");

export async function openAdminPanel() {
    const token = getToken();
    if (!token) return;
    try {
        const res = await fetch(`${API_BASE}/api/auth/admin-session`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            credentials: "include",
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            window.alert(data.error || data.message || "Не удалось открыть админку");
            return;
        }
        if (data.redirect) {
            window.open(`${API_BASE}${data.redirect}`, "_blank");
        }
    } catch {
        window.alert("Ошибка сети");
    }
}
